import { Link, Meta, Title } from "@solidjs/meta";
import { useParams } from "@solidjs/router";
import { HttpStatusCode } from "@solidjs/start";
import { Show } from "solid-js";
import { VENDORS } from "~/components/landing/compareData";
import { AlternativePage } from "~/components/landing/ComparePage";
import { getAppBaseUrl } from "~/lib/getAppBaseUrl";

export default function AlternativeRoute() {
  const params = useParams();
  const vendor = () => VENDORS.find((v) => v.key === params.vendor);

  return (
    <Show
      when={vendor()}
      keyed
      fallback={
        <>
          <HttpStatusCode code={404} />
          <Title>Page not found | Chief</Title>
          <p class="py-32 text-center text-lg text-secondary-text">Page not found.</p>
        </>
      }
    >
      {(match) => {
        const url = `${getAppBaseUrl()}/alternatives/${match.key}`;
        return (
          <>
            <Title>{match.title}</Title>
            <Meta name="description" content={match.description} />
            <Link rel="canonical" href={url} />
            <Meta property="og:title" content={match.title} />
            <Meta property="og:description" content={match.description} />
            <Meta property="og:url" content={url} />
            <AlternativePage vendor={match} />
          </>
        );
      }}
    </Show>
  );
}
